import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminHome = () => {
    const [classId, setClassId] = useState("1");
    const nav = useNavigate();

    return (
        <div>
            <h3>Адмінка</h3>

            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                <label>Клас:</label>
                <select value={classId} onChange={(e) => setClassId(e.target.value)}>
                    {Array.from({ length: 11 }, (_, i) => String(i + 1)).map((v) => (
                        <option key={v} value={v}>{v}</option>
                    ))}
                </select>

                <button onClick={() => nav(`classes/${classId}/subjects`)}>
                    До предметів
                </button>
            </div>
        </div>
    );
};

export default AdminHome;
